import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  animalImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 340,
    height: 340,
    maxWidth: '100%',
    maxHeight: '100%',
    aspectRatio: '1 / 1',
    overflow: 'hidden',
    position: 'relative',
    background: '#faf6f3',
    borderRadius: 20,
    boxSizing: 'border-box',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 20,
      display: 'block'
    },

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: 'auto'
    }
  },

  defaultImageContainer: {
    cursor: 'pointer',
    width: 340,
    height: 340,
    maxWidth: '100%',
    aspectRatio: '1 / 1',
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#faf6f3',
    margin: '0 auto',
    boxSizing: 'border-box',
    flexDirection: 'column',
    textAlign: 'center',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
      height: 'auto'
    }
  },

  defaultImage: {
    width: 220,
    height: 220,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: 220,
      maxheight: 220,
      objectFit: 'cover'
    },

    '& path': {
      fill: theme.palette.primary.main,
      opacity: 0.35
    }
  },

  addImageText: {
    marginTop: 8,
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 500,
    color: theme.palette.primary.main,
    textAlign: 'center',
    textWrap: 'wrap'
  },

  imageLoadingContainer: {
    width: 340,
    height: 340,
    maxWidth: '100%',
    maxHeight: '100%',
    aspectRatio: '1 / 1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#faf6f3',
    borderRadius: 20,
    boxSizing: 'border-box',
    margin: '0 auto'
  }
}))
